'use strict';

import $ from 'jquery';
import 'smoothstate';
import fitvids from 'fitvids';
// import matchHeight from 'jquery-match-height';

var smoothState;


(function() {
  
  // ===============
  // VARIABLES
  // ===============

  window.jQuery = $;
  window.$ = $;

  // Globals
  var glo_cookieCheckUTM = require('./functions/cookieCheckUTM');
  var glo_cookieSet = require('./functions/cookieSet');
  var glo_smoothScroll = require('./globals/smoothScroll');
  var glo_noImgDrag = require('./globals/noImgDrag');

  var glo_ghdLiveSearch = require('./globals/ghdLiveSearch');
  var glo_ghdTheme = require('./globals/ghdTheme');
  var glo_ghdVideoList = require('./globals/ghdVideoList');
  var glo_ghdVideoCourse = require('./globals/ghdVideoCourse');
  var glo_ghdVideoPlayer = require('./globals/ghdVideoPlayer');
  var glo_ghdBrandPromo = require('./globals/ghdBrandPromo');
  var glo_vimeoPlayer = require('./globals/vimeoPlayer');
  var glo_wpcf7 = require('./globals/wpcf7');

  

  // ===============
  // FUNCTIONS
  // ===============
  function ssBlacklistClass() {
    $("a").each(function() {
      var href = $(this).attr("href");
      if (
        href.indexOf("/wp-admin/") !== -1 ||
        href.indexOf("/wp-login.php") !== -1 ||
        href.indexOf("#") !== -1
      ) {
        // console.log(">:( blacklist " + href);
        $(this).addClass("no-smoothState");
      }
    });
  }

  function globalJS() {
    // console.log("> globalJS");

    glo_smoothScroll.init();
    glo_noImgDrag.init();
    
    glo_cookieCheckUTM.init();
    glo_cookieSet.init("utm_campaign");
    glo_cookieSet.init("utm_content");
    glo_cookieSet.init("utm_medium");
    glo_cookieSet.init("utm_source");
    glo_cookieSet.init("utm_term");
    glo_cookieSet.init("merchant_match");
    glo_cookieSet.init("promo");
    glo_cookieSet.init("ghd_brand");
    glo_cookieSet.init("ghd_user");

    glo_ghdLiveSearch.init("glo_ghdLiveSearch");
    glo_ghdTheme.init("glo_ghdTheme");
    glo_ghdVideoList.init("glo_ghdVideoList");
    glo_ghdVideoCourse.init("glo_ghdVideoCourse");
    glo_ghdVideoPlayer.init("glo_ghdVideoPlayer");
    glo_ghdBrandPromo.init("glo_ghdBrandPromo");
    glo_vimeoPlayer.init("glo_vimeoPlayer");
    glo_wpcf7.init("glo_wpcf7");

    fitvids({ 
      players: 'iframe[src^="https://fast.wistia.net"]'
    });
    
  
    // matchHeight();
  }; // globalJS

  
  var ssOptions = {
    prefetch: true,
    cacheLength: 2,
    anchors: "a",
    blacklist: "form, .no-smoothState",
    onStart: {
      duration: 250,
      render: function($container) {
        // console.log("onStart");
        $container.addClass("is-exiting").removeClass("first-load");
        smoothState.restartCSSAnimations();
      }
    },
    onProgress: {
      duration: 0.25,
      render: function($container) {
        // console.log("onProgress");
        $container.addClass("is-loading");
      }
    },
    onReady: {
      duration: 0,
      render: function($container, $newContent) {
        // console.log("onReady");
        $container.removeClass("is-exiting is-loading");
        $container.html($newContent);
      }
    },
    onAfter: function($container, $newContent) {
      // console.log("onAfter");
      ssBlacklistClass();
      globalJS(); // reinstate global scripts
    }
  };

  
  $(document).ready(function() {
    smoothState = $("#main").smoothState(ssOptions).data("smoothState");
    
    globalJS();
  });

})();